import { Breakpoint, Color } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${Color.Gray100};
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const LessonHeaderWrapper = styled.div`
  padding: 40px 16px;

  @media ${Breakpoint.SmallDesktop} {
    padding: 80px 80px 0;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
`;
